/**
 * Normalize a user-entered website URL.
 *
 *   "rudrasfoods.com"          → "https://rudrasfoods.com"
 *   "www.rudrasfoods.com"      → "https://www.rudrasfoods.com"
 *   "http://rudrasfoods.com"   → "http://rudrasfoods.com"   (preserved)
 *   "https://rudrasfoods.com"  → "https://rudrasfoods.com"  (preserved)
 *   ""                         → ""
 *   "   "                      → ""
 *
 * Never double-prepends a scheme. Trims leading/trailing whitespace.
 */
export function normalizeWebsiteUrl(input) {
  if (!input) return "";
  const trimmed = String(input).trim();
  if (!trimmed) return "";
  // Already has any scheme — leave it alone (backend will reject non-http/https).
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}
